import {useStompClient} from "react-stomp-hooks";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";

import {FC, memo } from "react";
import {IUser} from "../../store/sliceUser";
import {actions as actionCamera} from "../../store/sliceCamera";
import {actions as modal} from "../../store/sliceModal";

type SubscribeCameraProps = {
    name: string,
    sound?: boolean
}
const SubscribeCamera: FC<SubscribeCameraProps> = ({name, sound = false})  => {
    const stompClient = useStompClient();
    const dispatch = useDispatch<AppDispatch>();
    const user: IUser = useSelector((state: IRootState) => state.user.user)

    if (stompClient) {
        // fetchRefreshToken()
        //Send Message
        stompClient.subscribe("/topic/cam/" + name + "/" + user.id, (message) => {
            dispatch(actionCamera.setImage({name: name, message: message.body}));
        })

        stompClient.subscribe("/topic/cam/error/" + name + "/" + user.id, (message) => {
            dispatch(actionCamera.setError({name: name, message: message.body}));
        })

        if (sound) {
            stompClient.subscribe("/topic/audio/" + name + "/" + user.id, (message) => {
                dispatch(actionCamera.setAudio({name: name, message: message.body}));
            })
        }
    } else {
        //Handle error
    }


    return <div style={{visibility: "hidden"}}></div>

}

export default memo(SubscribeCamera)
